import { motion } from "framer-motion";
import { DollarSign, Users, TrendingUp, Coins } from "lucide-react";

const REFERIDOS = [
  { pack: "Starter", pays: "$50/mes", earn: "$5" },
  { pack: "Pro", pays: "$75/mes", earn: "$7,50" },
  { pack: "Elite", pays: "$95/mes", earn: "$9,50" },
];

export default function Monetizacion() {
  return (
    <section
      id="monetizacion"
      className="relative py-24 md:py-32 bg-[#060806]"
      data-testid="monetizacion-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
            / Sistema Monetizable
          </span>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase tracking-tight leading-none">
            Ganas <span className="italic text-[#BEDD7D]">estudiando</span>.
          </h2>
          <p className="mt-6 text-white/60 font-body">
            Dos vías de ingresos: Comisiones por Referidos y Profit del Mercado. Autofinanciable
            desde el primer mes.
          </p>
        </div>

        {/* Referidos card (full width) */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl border border-[#3E4D36]/60 bg-gradient-to-br from-[#1A2E1A]/60 to-black p-8 md:p-12 overflow-hidden max-w-4xl mx-auto"
          data-testid="referidos-card"
        >
          <div className="flex items-center gap-3 mb-6">
            <Users className="w-5 h-5 text-[#BEDD7D]" />
            <span className="text-xs font-display uppercase tracking-[0.3em] text-white/60">
              Comisiones por Referidos
            </span>
          </div>
          <h3 className="font-display font-bold text-3xl md:text-5xl uppercase leading-none">
            <span className="text-[#BEDD7D]">10%</span>
            <br />
            <span className="text-white/70 text-2xl md:text-3xl">
              por cada soldado que recluta.
            </span>
          </h3>
          <p className="mt-4 text-white/70 font-body max-w-2xl">
            El que recluta, cobra. Tu referido se entrena; tú generas. Comisión recurrente cada
            mes mientras tu referido siga activo.
          </p>

          <div className="mt-8 rounded-xl overflow-hidden border border-[#3E4D36]/40">
            <div className="grid grid-cols-3 gap-2 px-5 py-3 bg-[#1A2E1A]/60 text-[10px] font-display uppercase tracking-widest text-white/50">
              <span>Pack</span>
              <span>Paga</span>
              <span className="text-[#BEDD7D]">Ganas (10%)</span>
            </div>
            {REFERIDOS.map((r) => (
              <div
                key={r.pack}
                className="grid grid-cols-3 gap-2 px-5 py-3.5 border-t border-[#3E4D36]/30 text-sm items-center"
              >
                <span className="font-display uppercase tracking-wider text-white/80 text-xs">
                  {r.pack}
                </span>
                <span className="font-body text-white/60 text-xs">{r.pays}</span>
                <span className="font-display font-bold text-[#BEDD7D] text-lg">{r.earn}</span>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Bottom summary */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto"
        >
          {[
            { icon: DollarSign, label: "Autofinanciable", desc: "Las ganancias cubren tu inversión." },
            { icon: TrendingUp, label: "Monetizable", desc: "Ingresos desde el primer alumno activo." },
            { icon: Coins, label: "Escalable", desc: "Tu tropa crece, tus ingresos también." },
          ].map((s) => (
            <div
              key={s.label}
              className="flex items-start gap-4 p-6 rounded-2xl border border-[#3E4D36]/50 bg-[#1A2E1A]/30"
              data-testid={`monetizacion-feature-${s.label.toLowerCase()}`}
            >
              <div className="w-10 h-10 shrink-0 rounded-lg bg-black border border-[#BEDD7D]/30 flex items-center justify-center">
                <s.icon className="w-4 h-4 text-[#BEDD7D]" />
              </div>
              <div>
                <div className="font-display font-bold text-white uppercase tracking-wide">
                  {s.label}
                </div>
                <div className="mt-1 text-sm text-white/60 font-body">{s.desc}</div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
